import { ScrollReveal, AnimatedCounter } from "@/components/base/ScrollAnimations";
import { impactStats, sinceYear } from "@/mocks/homeData";

export default function ImpactSection() {
  return (
    <section className="bg-tie-navy py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {impactStats.map((stat, index) => (
            <ScrollReveal key={stat.label} delay={index * 100}>
              <div className="text-center md:text-left p-4 md:p-6 rounded-xl bg-white/5 border border-white/10">
                <div className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white">
                  <AnimatedCounter target={stat.value} suffix={stat.suffix} />
                </div>
                <p className="mt-2 text-sm md:text-base text-white/60">
                  {stat.label}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>

        {/* Since Label */}
        <ScrollReveal delay={400}>
          <div className="mt-8 md:mt-12 text-center">
            <p className="text-sm md:text-base text-tie-teal-light font-medium">
              {sinceYear}
            </p>
          </div>
        </ScrollReveal>

        {/* Association Strip */}
        <ScrollReveal delay={500}>
          <div className="mt-10 md:mt-14 pt-8 md:pt-10 border-t border-white/10">
            <p className="text-center text-xs md:text-sm text-white/50 uppercase tracking-wider mb-4">
              In Collaboration & Association With
            </p>
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-10">
              <div className="flex items-center gap-3 px-5 py-3 rounded-lg bg-white/5 border border-white/10">
                <div className="w-10 h-10 rounded-full bg-tie-teal/20 flex items-center justify-center">
                 <img src="/assets/images/logo/itet.jpg" alt="ITET Logo" width={30} height={30} className="object-contain" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-white">ITET</p>
                  <p className="text-xs text-white/50">
                   Institute of Textile Engineers & Technologists
                  </p>
                </div>
              </div>
               <div className="hidden md:block text-white/30">|</div>
              <div className="flex items-center gap-3 px-5 py-3 rounded-lg bg-white/5 border border-white/10">
                <div className="w-10 h-10 rounded-full bg-tie-teal/20 flex items-center justify-center">
                 <img src="/assets/images/logo/bkmea.jpg" alt="BKMEA Logo" width={50} height={50} className="object-contain" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-white">BKMEA</p>
                  <p className="text-xs text-white/50">
                    Bangladesh Knitwear Manufacturers & Exporters Association
                  </p>
                </div>
              </div>
              <div className="hidden md:block text-white/30">|</div>
              <div className="flex items-center gap-3 px-5 py-3 rounded-lg bg-white/5 border border-white/10">
                <div className="w-10 h-10 rounded-full bg-tie-teal/20 flex items-center justify-center">
                  <img src="/assets/images/logo/bgba.png" alt="BGBA Logo" width={50} height={50} className="object-contain" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-white">BGBA</p>
                  <p className="text-xs text-white/50">
                    Bangladesh Garment Buying House Association
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}